<template>
  <div id="users" class="px-4 py-4">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'user-create' })"
      >
        <v-icon left>
          add_circle
        </v-icon>
        Add
      </v-btn>
    </div>
    <user-list />
  </div>
</template>
<script>
import UserList from "@/components/user_management/UserList.vue";
export default {
  components: {
    UserList
  }
};
</script>
